import { AxiosResponse } from 'axios';
import { API } from '../api/api';
import {
  ApiResponse,
  DataDueDiligence,
  Nullable
} from '../types/types';
import { BaseEntityService } from './data';

type DeleteDdReturnType = Promise<AxiosResponse<ApiResponse<Nullable<DataDueDiligence>>>>;

export class DueDiligenceDevService {
  deleteDD(ddId: string) : DeleteDdReturnType {
    const path = `/api/v1/dds/${ddId}/dev/deleteDD`;

    return API.get(path);
  }
}

export class DdPublishListingService extends BaseEntityService<DataDueDiligence> {
  constructor() {
    super();
  }

  getBaseUrl() : string {
    return '/api/v1/dds/publish/nonSuccessful';
  }
}

export class DdPublishService extends BaseEntityService<DataDueDiligence> {
  constructor() {
    super();
  }

  getBaseUrl() : string {
    return '/api/v1/dds/publish';
  }

  async performPublish(ddId: string): Promise<ApiResponse<Nullable<DataDueDiligence>>> {
    return API.get(`${this.getBaseUrl()}/performPublish?id=${ddId}`)
      .then(res => this.handleResponse<DataDueDiligence>(res));
  }

  async cancelPublish(ddId: string): Promise<ApiResponse<Nullable<DataDueDiligence>>> {
    return API.get(`${this.getBaseUrl()}/cancelPublish?id=${ddId}`)
      .then(res => this.handleResponse<DataDueDiligence>(res));
  }
}
